<template>
  <div class="register-container">
    <div class="register-card">
      <h2>Crear Cuenta</h2>
      
      <div v-if="error" class="error-message">
        {{ error }}
      </div>
      
      <form @submit.prevent="handleSubmit">
        <div class="form-group">
          <label for="username">Usuario</label>
          <input 
            id="username" 
            v-model="username" 
            type="text" 
            required
            autocomplete="username"
          />
        </div>
        
        <div class="form-group">
          <label for="email">Correo Electrónico</label>
          <input 
            id="email" 
            v-model="email" 
            type="email" 
            required
            autocomplete="email"
          />
        </div>
        
        <div class="form-group">
          <label for="password">Contraseña</label>
          <input 
            id="password" 
            v-model="password" 
            type="password" 
            required
            autocomplete="new-password"
          />
          <small>La contraseña debe tener al menos 6 caracteres</small>
        </div>
        
        <div class="form-group">
          <label for="confirmPassword">Confirmar Contraseña</label>
          <input 
            id="confirmPassword" 
            v-model="confirmPassword" 
            type="password" 
            required
            autocomplete="new-password"
          />
        </div>
        
        <button 
          type="submit" 
          :disabled="loading || !isValid"
          class="btn-primary"
        >
          {{ loading ? 'Registrando...' : 'Registrarse' }}
        </button>
        
        <div class="login-link">
          ¿Ya tienes cuenta? <router-link to="/login">Iniciar Sesión</router-link>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { ref, computed } from 'vue'
import { useStore } from 'vuex'

export default {
  name: 'RegisterView',
  setup() {
    const store = useStore()
    const username = ref('')
    const email = ref('')
    const password = ref('')
    const confirmPassword = ref('')
    
    const loading = computed(() => store.state.auth.loading)
    const error = computed(() => store.state.auth.error)
    
    const isValid = computed(() => {
      return (
        username.value.length > 0 &&
        email.value.includes('@') &&
        password.value.length >= 6 &&
        password.value === confirmPassword.value
      )
    })
    
    const handleSubmit = async () => {
      if (!isValid.value) return
      
      await store.dispatch('auth/register', {
        username: username.value,
        email: email.value,
        password: password.value
      })
    }
    
    return {
      username,
      email,
      password,
      confirmPassword,
      loading,
      error,
      isValid,
      handleSubmit
    }
  }
}
</script>

<style lang="scss" scoped>
.register-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 80vh;
}

.register-card {
  width: 100%;
  max-width: 400px;
  padding: 2rem;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  
  h2 {
    margin-bottom: 1.5rem;
    text-align: center;
    color: #333;
  }
}

.form-group {
  margin-bottom: 1rem;
  
  label {
    display: block;
    margin-bottom: 0.5rem;
    font-weight: 500;
  }
  
  input {
    width: 100%;
    padding: 0.75rem;
    border: 1px solid #ddd;
    border-radius: 4px;
    
    &:focus {
      outline: none;
      border-color: #4299e1;
    }
  }
  
  small {
    display: block;
    margin-top: 0.25rem;
    color: #718096;
  }
}

.btn-primary {
  display: block;
  width: 100%;
  padding: 0.75rem;
  margin-top: 1.5rem;
  background-color: #4299e1;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  
  &:hover {
    background-color: #3182ce;
  }
  
  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
}

.login-link {
  margin-top: 1rem;
  text-align: center;
  
  a {
    color: #4299e1;
    text-decoration: none;
    
    &:hover {
      text-decoration: underline;
    }
  }
}

.error-message {
  padding: 0.75rem;
  margin-bottom: 1rem;
  background-color: #fed7d7;
  color: #c53030;
  border-radius: 4px;
  font-size: 0.875rem;
}
</style>